/** @type {Styles} */
export const styles = {
  root: {
    '& .MuiPaper-root': {
      height: '50%',
      maxHeight: 'calc(100% - 40px)',
      bottom: 0,
      position: 'absolute',
      right: 0,
      left: 0,
      width: '100%',
      borderRadius: 2,
    },

    '& .MuiDialogContent-root': {
      width: '100%',
      margin: 0,
      padding: 0,
    },
  },

  dialogContent: {
    padding: 0,
  },
}
